<template>
  <div>
    <GmapMap
      :center="{lat: 44.801545, lng:20.458796}"
      :zoom="7"
      ref="map"
      :style="style"
      :options="{ streetViewControl: false }"
    ></GmapMap>
    <RetroactivePoiResult v-if="retroactivePoiEnters.length" :poiEnters="retroactivePoiEnters"/>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import { mapState } from 'vuex'
import { MapDataAdapterFactory } from '@/utils/map/mapDataMutatorStrategy'
import BaseGoogleMapComponent from '../BaseGoogleMapComponent'
import EventBus from '../../../event-bus'

export default {
  extends: BaseGoogleMapComponent,
  name: 'GoogleRetroactivePoiEnteranceComponent',
  components: {
    MapCrudComponent: () => import('@/components/map/MapCrudComponent'),
    SubmitGroup: () => import('@/components/SubmitGroup'),
    BaseDialogTitle: () => import('@/components/BaseDialogTitle'),
    RetroactivePoiResult: () =>
      import('@/components/map/retroactivePoi/RetroactivePoiResult')
  },
  data() {
    return {
      drawingManger: null,
      closeOnSubmit: false,
      defaultElementConfig: {
        strokeOpacity: 0.8,
        strokeWeight: 1.5,
        fillOpacity: 0.4,
        editable: true,
        draggable: true
      }
    }
  },
  computed: {
    google: gmapApi,
    ...mapState('map', ['pois']),
    ...mapState('retroactivePoi', ['retroactivePoiEnters']),
    style() {
      return this.retroactivePoiEnters && this.retroactivePoiEnters.length
        ? 'height: 60vh'
        : 'height: 100vh'
    }
  },
  mounted() {
    var interval = setInterval(() => {
      if (this.google) {
        clearInterval(interval)
        this.drawingManger = new this.google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: this.google.maps.ControlPosition.TOP_LEFT,
            drawingModes: ['circle', 'polygon']
          },
          circleOptions: {
            editable: true,
            draggable: true
          },
          polygonOptions: {
            editable: true,
            draggable: true
          }
        })

        this.drawingManger.setMap(this.$refs.map.$mapObject)

        this.google.maps.event.addListener(
          this.drawingManger,
          'overlaycomplete',
          event => {
            this.drawingManger.setDrawingMode(null)

            this.handleOverlayCompleted(event)
          }
        )
      }
    }, 300)
  },
  methods: {
    handleOverlayCompleted(event) {
      if (event.type == 'circle') {
        this.handleCircleOverlayCreated(event.overlay)
      }

      if (event.type == 'polygon') {
        this.handlePolygonOverlayCreated(event.overlay)
      }
    },
    handleCircleOverlayCreated(circle) {
      if (circle._id == undefined) {
        circle._id = ''
        circle._poiName = ''
        circle._restrictionType = ''
        circle._color = '#1CE'
      }
      circle._type = 0

      var data = {
        circle: circle
      }

      data.eventType = 'CIRCLE'
      this.displayTemporaryPoi(data)
    },
    handlePolygonOverlayCreated(polygon) {
      if (polygon._id == undefined) {
        polygon._id = ''
        polygon._poiName = ''
        polygon._restrictionType = ''
        polygon._color = '#1CE'
      }
      polygon._type = 1

      let data = {
        polygon: polygon
      }

      data.eventType = 'POLYGON'
      this.displayTemporaryPoi(data)
    },
    displayTemporaryPoi(data) {
      var factory = new MapDataAdapterFactory()
      var strategy = factory.make('google')
      var poi = strategy.adapt(data)
      EventBus.$emit('TEMPORARY_POI', poi)
    }
  }
}
</script>
<style>
#googleMap {
  width: 100%;
  height: 863px;
}
.mapFullHeight {
  height: 94.4vh;
}
.mapNotFullHeight {
  height: 60.4vh;
}
.gm-style-iw {
  width: 350px !important;
  max-width: 350px !important;
}
</style>
